export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');
  const slides = node.dataset.slides || 4;
  const stackOnMobile = node.dataset.stackMobile === 'true';
  const prevButton = node.querySelector('.swiper-button-prev-custom');
  const nextButton = node.querySelector('.swiper-button-next-custom');
  /**
   * Functions
   */
  const initSwiper = () => {
    new Swiper(swiperContainer, {
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        // Screens <768px
        0: {
          slidesPerView: 1.2,
          enabled: !stackOnMobile,
        },
        // Screens ≥768px (md and up)
        768: {
          slidesPerView: Number(slides) > 4 ? 4.2 : Number(slides),
          enabled: true,
        },
      },
    });
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) {
      initSwiper();
    }
  };

  init();
};
